module.exports = __webpack_public_path__ + "img/title_bg.c8e84374.png";